import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/customers/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddContactModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { Breadcrumbs } from "@mui/material"
import { useState } from "react"

export default function CustomerList() {
  const breadcrumbs = [{ label: "Dashboard", url: "/" }, { label: "Customers" }]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Customers</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <CustomerTable />
      </CrudProvider>
    </>
  )
}

function CustomerTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Customer"
        columns={columns}
        apiPath="customer"
        onImport={true}
        onExport={true}
      />

      {openDialog ? <AddContactModal /> : null}
    </>
  )
}
